import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetotrimbkeshwarbusrental() {



const cardData =
{
  keyword: 'Pune to Trimbakeshwar Bus Rental',
  heading: 'Sanavi Travels: Pune to Trimbakeshwar Bus Rental',
  headingDescription: 'Sanavi Travels provides safe, comfortable, and well-organized Pune to Trimbakeshwar Bus Rental services for devotees, families, senior citizens, group pilgrims, corporate spiritual tours, wedding groups, and leisure travelers. Trimbakeshwar, one of the twelve Jyotirlingas of Lord Shiva, is a highly revered pilgrimage destination near Nashik and attracts thousands of devotees throughout the year. The journey from Pune to Trimbakeshwar involves long highway travel, ghat sections, and temple-area traffic, making organized group transport essential for a peaceful darshan experience.',

  top: 'Spiritual & Group Travel Experiences with Pune to Trimbakeshwar Bus Rental',

  "topPlaces": [
    {
      "title": "Trimbakeshwar Jyotirlinga Darshan",
      "description": "Trimbakeshwar temple is one of the most sacred Jyotirlingas of Lord Shiva. Traveling by rented bus allows devotees to reach the temple calmly, stay together as a group, and focus entirely on darshan without travel stress, parking issues, or route confusion."
    },
    {
      "title": "Comfortable Long-Distance Travel from Pune",
      "description": "The Pune to Trimbakeshwar journey covers long highway stretches and ghat roads. Bus rental ensures comfortable seating, relaxed travel, and reduced fatigue, especially for senior citizens and large pilgrim groups."
    },
    {
      "title": "Family Pilgrimage Tours",
      "description": "Families prefer bus rental for Trimbakeshwar darshan to travel together safely, carry puja items easily, and enjoy a peaceful spiritual journey without coordination issues."
    },
    {
      "title": "Group & Mandal Yatra",
      "description": "Religious groups, mandals, and community yatras benefit from bus hire as it ensures disciplined group movement, proper scheduling, and smooth temple visits."
    },
    {
      "title": "Corporate Spiritual Tours",
      "description": "Many companies organize spiritual retreats and group darshan trips. Bus rental provides professional and punctual transportation for corporate teams traveling to Trimbakeshwar."
    },
    {
      "title": "Wedding & Family Ritual Travel",
      "description": "Trimbakeshwar is often visited for religious rituals and family ceremonies. Hiring a bus ensures timely arrival, comfort, and hassle-free transportation for relatives and guests."
    },
    {
      "title": "One-Day & Multi-Day Trimbakeshwar Trips",
      "description": "Depending on darshan plans, groups can opt for one-day or overnight trips. Bus rental offers flexibility in planning halts, rest breaks, and temple timings."
    },
    {
      "title": "Safe Ghat & Highway Driving",
      "description": "Experienced drivers ensure safe navigation through ghat sections and highways, especially during monsoon and peak pilgrimage seasons."
    },
    {
      "title": "Stress-Free Group Coordination",
      "description": "Traveling in a single bus avoids confusion, delays, and convoy risks, making the entire pilgrimage smooth and organized."
    },
    {
      "title": "Peaceful & Devotional Travel Experience",
      "description": "Bus travel promotes unity, discipline, and calmness among pilgrims, enhancing the spiritual significance of the Trimbakeshwar journey."
    }
  ],

  "services": [
    {
      "name": "Pune to Trimbakeshwar Bus Rental",
      "description": "Sanavi Travels offers dedicated bus rental services from Pune to Trimbakeshwar for pilgrimage, family travel, and group tours. Our service focuses on safety, comfort, and well-coordinated travel for devotees."
    },
    {
      "name": "AC Bus Pune to Trimbakeshwar",
      "description": "AC buses provide a cool and comfortable environment, ideal for long-distance travel and summer pilgrimage journeys."
    },
    {
      "name": "Non AC Bus Rental Pune to Trimbakeshwar",
      "description": "Non AC buses are a cost-effective option for devotional groups while maintaining reliability, safety, and seating comfort."
    },
    {
      "name": "Luxury Bus Pune to Trimbakeshwar",
      "description": "Luxury buses with premium interiors and smooth suspension are suitable for senior citizen groups and premium pilgrimage tours."
    },
    {
      "name": "Mini Bus Hire Pune to Trimbakeshwar",
      "description": "Mini buses are ideal for small families and private groups, offering flexibility and easy maneuvering on temple access roads."
    },
    {
      "name": "32 Seater Bus Pune to Trimbakeshwar",
      "description": "32 seater buses are perfect for medium-sized pilgrim groups, providing a balance of seating capacity and travel comfort."
    },
    {
      "name": "35 Seater Bus Hire Pune to Trimbakeshwar",
      "description": "35 seater buses are suitable for large groups, mandals, and religious organizations traveling together."
    },
    {
      "name": "Bus with Driver Pune to Trimbakeshwar",
      "description": "All bus rentals include experienced drivers familiar with pilgrimage routes, temple timings, and safe highway driving."
    },
    {
      "name": "Affordable Bus Rental Pune to Trimbakeshwar",
      "description": "We offer budget-friendly packages for Trimbakeshwar darshan without compromising on vehicle quality or safety."
    },
    {
      "name": "Group Bus Hire Pune to Trimbakeshwar",
      "description": "Group bus hire ensures everyone travels together comfortably, improving coordination and spiritual focus."
    }
  ],

  "tableData": [
    ["Pune to Trimbakeshwar Bus", "AC Bus"],
    ["Non AC Bus", "Luxury Bus"],
    ["Mini Bus", "32 Seater Bus"],
    ["35 Seater Bus", "Group Travel"],
    ["Family Trip", "Pilgrimage Tour"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Experienced Pilgrimage Drivers", "WhyChoosedescription": "Drivers familiar with Pune–Trimbakeshwar routes and temple access roads." },
    { "WhyChooseheading": "Comfortable Long-Distance Travel", "WhyChoosedescription": "Spacious seating and smooth rides for extended journeys." },
    { "WhyChooseheading": "Safe & Maintained Buses", "WhyChoosedescription": "Regular servicing, cleanliness, and safety checks." },
    { "WhyChooseheading": "Flexible Trip Planning", "WhyChoosedescription": "One-day and multi-day travel options available." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "Clear pricing with no hidden charges." },
    { "WhyChooseheading": "Group-Friendly Travel", "WhyChoosedescription": "Entire group travels together peacefully." },
    { "WhyChooseheading": "Reliable Travel Partner", "WhyChoosedescription": "Sanavi Travels is trusted for pilgrimage transport." },
    { "WhyChooseheading": "24/7 Support", "WhyChoosedescription": "Assistance available for planning and travel queries." }
  ]
};

const faqData = [
  { question: 'Do you provide Pune to Trimbakeshwar bus rental?', answer: 'Yes, Sanavi Travels offers bus rental services from Pune to Trimbakeshwar.' },
  { question: 'Are AC buses available for Trimbakeshwar trips?', answer: 'Yes, both AC and Non AC buses are available.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, our comfortable buses and experienced drivers make it suitable for seniors.' },
  { question: 'Can we plan a one-day Trimbakeshwar trip?', answer: 'Yes, one-day and multi-day packages are available.' },
  { question: 'Are drivers experienced with pilgrimage routes?', answer: 'Yes, our drivers are familiar with Trimbakeshwar routes and temple access.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, advance booking is advised during weekends and festivals.' },
  { question: 'Are buses cleaned before travel?', answer: 'Yes, all buses are thoroughly cleaned and checked before departure.' },
  { question: 'Can groups and mandals hire buses?', answer: 'Yes, group and mandal bus hire is available.' },
  { question: 'Do you offer affordable packages?', answer: 'Yes, we provide competitive and transparent pricing.' },
  { question: 'Is pickup available from Pune?', answer: 'Yes, pickup is available from Pune and nearby areas.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Deshpande',
    feedback: 'Our Trimbakeshwar darshan from Pune was very smooth and comfortable. Excellent service by Sanavi Travels.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Sunita Kulkarni',
    feedback: 'Clean bus, polite driver, and perfect planning for our family pilgrimage. Highly recommended.',
    rating: 5
  }
];

















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Trimbakeshwar Bus Rental - Sanavi Travels",
  "description": "Sanavi Travels offers bus rentals from Pune to Trimbakeshwar for family trips, corporate travel, group tours, weddings, and picnics. AC and Non-AC buses, mini buses, 32-seater and 35-seater options are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};







  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Pune to Trimbakeshwar Bus Rental | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book buses from Pune to Trimbakeshwar with Sanavi Travels. AC & Non-AC 32-seater, 35-seater buses and mini buses for family trips, corporate travel, group tours, weddings, and picnics with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/282.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetotrimbkeshwarbusrental;